import Axios from "../utils/tms-axios/tms-axios";

export const DutyServices = {
  createDutyPass: async (body) => {
    const resp = await Axios.post(`em/duty-pass`, body, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        "X-Temple-Id": localStorage.getItem("templeId"),
      },
    });
    return resp.data;
  },

  getDutyPasses: async () => {
    const resp = await Axios.get(`em/duty-pass`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        "X-Temple-Id": localStorage.getItem("templeId"),
      },
    });
    return resp.data;
  },

  updateDutyPass: async (id, body) => {
    const resp = await Axios.patch(`em/duty-pass/${id}`, body, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        "X-Temple-Id": localStorage.getItem("templeId"),
      },
    });
    return resp.data;
  },

  deleteDutyPass: async (id) => {
    const resp = await Axios.delete(`em/duty-pass/${id}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        "X-Temple-Id": localStorage.getItem("templeId"),
      },
    });
    return resp.data;
  },

  scanDutyPass: async (id) => {
    const resp = await Axios.get(
      `em/duty-pass-scan/${id}`,
      {},
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
          "X-Temple-Id": localStorage.getItem("templeId"),
        },
      }
    );
    return resp.data;
  },

  getDutyPassScanById: async (id) => {
    const resp = await Axios.get(`em/duty-pass-scan/track/${id}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        "X-Temple-Id": localStorage.getItem("templeId"),
      },
    });
    return resp.data;
  },

  getDutyPassScanLogs: async () => {
    const resp = await Axios.get(`em/duty-pass-scan/logs`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        "X-Temple-Id": localStorage.getItem("templeId"),
      },
    });
    return resp.data;
  },

  createDutyCounter: async (body) => {
    const resp = await Axios.post(`em/duty-pass-counter/create`, body, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        "X-Temple-Id": localStorage.getItem("templeId"),
      },
    });
    return resp.data;
  },

  getDutyPassCounters: async () => {
    const resp = await Axios.get(`em/duty-pass-counter/all`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        "X-Temple-Id": localStorage.getItem("templeId"),
      },
    });
    return resp.data;
  },

  deleteWalkerCounter: async (id) => {
    const resp = await Axios.delete(`em/duty-pass-counter/delete/${id}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        "X-Temple-Id": localStorage.getItem("templeId"),
      },
    });
    return resp.data;
  },
};
